import { Kettle } from '@execonline-inc/kettle.private';
import { Error } from '../ErrorHandling';
import { LectureSegment } from '../LectureStore/Types';

interface Waiting {
  kind: 'waiting';
  segment: LectureSegment;
  kettle: Kettle;
}

interface Loading {
  kind: 'loading';
  segment: LectureSegment;
  kettle: Kettle;
}

interface PlayerReady {
  kind: 'player-ready';
  segment: LectureSegment;
  kettle: Kettle;
  iframeRef: React.RefObject<HTMLIFrameElement | null>;
}

interface WaitingForVideo {
  kind: 'waiting-for-video';
  segment: LectureSegment;
  kettle: Kettle;
  iframeRef: React.RefObject<HTMLIFrameElement | null>;
}

interface Ready {
  kind: 'ready';
  segment: LectureSegment;
  kettle: Kettle;
  iframeRef: React.RefObject<HTMLIFrameElement | null>;
}

interface Advancing {
  kind: 'advancing';
  segment: LectureSegment;
  kettle: Kettle;
  iframeRef: React.RefObject<HTMLIFrameElement | null>;
  advancingToStep: number;
}

export const waiting = (segment: LectureSegment, kettle: Kettle): Waiting => ({
  kind: 'waiting',
  segment,
  kettle,
});

export const loading = (segment: LectureSegment, kettle: Kettle): Loading => ({
  kind: 'loading',
  segment,
  kettle,
});

export const playerReady = (
  segment: LectureSegment,
  kettle: Kettle,
  iframeRef: React.RefObject<HTMLIFrameElement | null>,
): PlayerReady => ({
  kind: 'player-ready',
  segment,
  kettle,
  iframeRef,
});

export const waitingForVideo = (
  segment: LectureSegment,
  kettle: Kettle,
  iframeRef: React.RefObject<HTMLIFrameElement | null>,
): WaitingForVideo => ({
  kind: 'waiting-for-video',
  segment,
  kettle,
  iframeRef,
});

export const ready = (
  segment: LectureSegment,
  kettle: Kettle,
  iframeRef: React.RefObject<HTMLIFrameElement | null>,
): Ready => ({
  kind: 'ready',
  segment,
  kettle,
  iframeRef,
});

export const advancing = (
  step: number,
  segment: LectureSegment,
  kettle: Kettle,
  iframeRef: React.RefObject<HTMLIFrameElement | null>,
): Advancing => ({
  kind: 'advancing',
  segment,
  kettle,
  iframeRef,
  advancingToStep: step,
});

export type ConvertedPptState =
  | Waiting
  | Loading
  | PlayerReady
  | WaitingForVideo
  | Ready
  | Error
  | Advancing;
